module.exports = __webpack_public_path__ + "1b3d12bef62c6fe500861a6dd0d9bdf6.png";